import React from 'react';
import './TermsOkSection.css';

export const TermsOkSection = ({ onClick, buttonText }) =>
    <div className="terms-modal-button__wrapper">
        <button
            className="terms-modal-button"
            onClick={onClick}
        >
            {buttonText}
        </button>
    </div>;
